import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69f78dd9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "session-list-item__cell" }
const _hoisted_2 = { class: "ms-3" }
const _hoisted_3 = { class: "session-list-item__cell" }
const _hoisted_4 = { class: "session-list-item__cell" }
const _hoisted_5 = { class: "session-list-item__cell" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 2,
  class: "me-3"
}
const _hoisted_9 = { class: "session-list-item__cell session-list-item__documents" }

import { ref } from 'vue'
import { SessionListItemViewModel } from '../SessionListItem/SessionListItem.interfaces'
import DocumentIcon from '@/icons/DocumentIcon.vue'
import DocumentDownloadModal from '../DocumentDownloadModal/DocumentDownloadModal.vue'
import { useClassroomStudentService } from '../ClassroomStudentService'
import { downloadFile } from '@/utils/downloadFile'


export default /*#__PURE__*/_defineComponent({
  __name: 'WebinarListItem',
  props: {
    modelValue: {},
    disabled: { type: Boolean },
    isLastRow: { type: Boolean }
  },
  setup(__props: any) {

const props =
  __props

const dateString = props.modelValue.localStartDateTime.toLocaleString('en-us', {month: 'long', day: 'numeric', year: 'numeric'})
const hasWebinarPassed = props.modelValue.localEndDateTime < new Date()
const hasDocuments = props.modelValue.event.documentFileNames?.length > 0

const classroomStudentService = useClassroomStudentService()
const showDocumentDownloadModal = ref(false)
const documentsDownloading = ref([''])

function handleDownloadDocuments() {
  if (props.modelValue.event.documentFileNames.length === 1) {
    downloadFiles([props.modelValue.event.documentFileNames[0]])
  } else {
    openDocumentDownloadModal()
  }
}

async function downloadFiles(fileNameList: string[]) {
  documentsDownloading.value = [ ...fileNameList ]
  try {
    await fileNameList.forEach(async (fileName) => {
      const file = await classroomStudentService.fetchEventDocument(props.modelValue.sessionId, fileName)
      if (file) {
        downloadFile(file, fileName)
        documentsDownloading.value = documentsDownloading.value.filter(f => f !== fileName)
      }
    })
  } catch (e) {
    documentsDownloading.value = []
    throw e
  }
}

function openDocumentDownloadModal() {
  showDocumentDownloadModal.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      class: _normalizeClass({'session-list-item': true, 'grey-line': !props.isLastRow})
    }, [
      _createElementVNode("td", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.modelValue.event.description), 1)
      ]),
      _createElementVNode("td", _hoisted_3, _toDisplayString(_unref(dateString)), 1),
      _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.modelValue.localStartEndTime), 1),
      _createElementVNode("td", _hoisted_5, [
        (!hasWebinarPassed)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "me-3",
              href: _ctx.modelValue.event.meetingLink
            }, " Webinar Link ", 8, _hoisted_6))
          : (_ctx.modelValue.event.recordingLink)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "me-3",
                href: _ctx.modelValue.event.recordingLink
              }, " Recorded Webinar Link ", 8, _hoisted_7))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, " Unavailable "))
      ]),
      _createElementVNode("td", _hoisted_9, [
        hasDocuments
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn rounded-0",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleDownloadDocuments()))
            }, [
              _createVNode(DocumentIcon)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createVNode(DocumentDownloadModal, {
      visible: showDocumentDownloadModal.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((showDocumentDownloadModal).value = $event)),
      "file-names": _ctx.modelValue.event.documentFileNames ?? [],
      "documents-downloading": documentsDownloading.value,
      onDownloadFiles: downloadFiles
    }, null, 8, ["visible", "file-names", "documents-downloading"])
  ], 64))
}
}

})